import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';
import Toggle from 'react-toggle';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

const clientAccessFields = [
  { key: 'real_time_labor', label: 'Usado em Real Time Labor?' },
  { key: 'dashboard', label: 'Usado em Dashboard?' },
  { key: 'sigs_ai', label: 'Usado em SIGS AI?' },
  { key: 'instruction_sheets', label: 'Usado em Fichas de Instrução?' },
  { key: 'reports_hub', label: 'Usado em Central de Relatórios?' },
  { key: 'planejamento', label: 'Usado em Planejamento?' },
  { key: 'segvoos', label: 'Usado em SegVoo?' },
  { key: 'escalas', label: 'Usado em Escalas?' },
  { key: 'portal', label: 'Usado em Cockpit?' },
];

class SigtripUsersEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      staff_list_sigtrip: [],
      staff_list_sigmec: [],
      staff_list_sigtrein: [],
      data_groups: [],
      data_groups_sigmec: [],
      data_groups_sigtrein: [],
      user_companies: [],
      name: '',
      email: '',
      id: '',
      sigtrip_id: '',
      sigmec_id: '',
      sigtrein_id: '',
      sigtrip: 0,
      sigrfms: 1,
      sigmec: 0,
      sigtrein: 0,
      exam_instructor: 0,
      real_time_labor: 0,
      dashboard: 0,
      sigs_ai: 0,
      instruction_sheets: 0,
      reports_hub: 0,
      planejamento: 0,
      segvoos: 0,
      escalas: 0,
      portal: 0,
      original_data: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.edit = this.edit.bind(this);
    this.syncInfo = this.syncInfo.bind(this);
    this.loadData = this.loadData.bind(this);
    this.addCompany = this.addCompany.bind(this);
    this.deleteCompany = this.deleteCompany.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  // Handlers
  handleCheckboxChangeGroups (name, event) {
    var change = {};
    var data_temp = [];
    var self = this;
    Object.keys(this.state.data_groups).map(function(k) {
      if(self.state.data_groups[k].id === name) {
        change = {
          checked: event.target.checked,
          group: self.state.data_groups[k].group,
          id: self.state.data_groups[k].id,
        };

      } else {
        change = {
          checked: self.state.data_groups[k].checked,
          group: self.state.data_groups[k].group,
          id: self.state.data_groups[k].id,
        };
      }
      data_temp.push(change);
    });
    this.setState({data_groups: data_temp});
  }

  handleCheckboxChangeGroupsSigmec (name, event) {
    var change = {};
    var data_temp = [];
    var self = this;
    Object.keys(this.state.data_groups_sigmec).map(function(k) {
      if(self.state.data_groups_sigmec[k].id === name) {
        change = {
          checked: event.target.checked,
          group: self.state.data_groups_sigmec[k].group,
          id: self.state.data_groups_sigmec[k].id,
        };

      } else {
        change = {
          checked: self.state.data_groups_sigmec[k].checked,
          group: self.state.data_groups_sigmec[k].group,
          id: self.state.data_groups_sigmec[k].id,
        };
      }
      data_temp.push(change);
    });
    this.setState({data_groups_sigmec: data_temp});
  }

  handleCheckboxChangeGroupsSigtrein (name, event) {
    var change = {};
    var data_temp = [];
    var self = this;
    Object.keys(this.state.data_groups_sigtrein).map(function(k) {
      if(self.state.data_groups_sigtrein[k].id === name) {
        change = {
          checked: event.target.checked,
          group: self.state.data_groups_sigtrein[k].group,
          id: self.state.data_groups_sigtrein[k].id,
        };

      } else {
        change = {
          checked: self.state.data_groups_sigtrein[k].checked,
          group: self.state.data_groups_sigtrein[k].group,
          id: self.state.data_groups_sigtrein[k].id,
        };
      }
      data_temp.push(change);
    });
    this.setState({data_groups_sigtrein: data_temp});
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigtrip') + '/usuario/editar/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            email: responseJson.data.main.email,
            sigtrip_id: responseJson.data.main.sigtrip_id,
            sigmec_id: responseJson.data.main.sigmec_id,
            sigtrein_id: responseJson.data.main.sigtrein_id,
            sigtrip: responseJson.data.main.sigtrip,
            sigrfms: 1,
            sigtrein: responseJson.data.main.sigtrein,
            exam_instructor: responseJson.data.main.exam_instructor,
            sigmec: responseJson.data.main.sigmec,
            real_time_labor: responseJson.data.main.real_time_labor,
            dashboard: responseJson.data.main.dashboard,
            sigs_ai: responseJson.data.main.sigs_ai,
            instruction_sheets: responseJson.data.main.instruction_sheets,
            reports_hub: responseJson.data.main.reports_hub,
            planejamento: responseJson.data.main.planejamento,
            segvoos: responseJson.data.main.segvoos,
            escalas: responseJson.data.main.escalas,
            portal: responseJson.data.main.portal,
            companies_select: responseJson.data.companies_select,
            user_companies: responseJson.data.user_companies,
          });
        }
      }).then(() => {
      var url = config.get('api_sigtrip') + '/usuario/grupos/permissao/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_groups: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api_sigtrein') + '/usuario/grupos/permissao/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_groups_sigtrein: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api_sigmec') + '/usuario/grupos/permissao/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_groups_sigmec: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api_sigtrip') + '/tripulantes/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_list_sigtrip: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api_sigmec') + '/colaboradores/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({staff_list_sigmec: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api_sigtrein') + '/alunos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({staff_list_sigtrein: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); }); }); }); }); }); });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    // Salva grupos do sigtrip
    let datasave = {
      data: this.state.data_groups,
      user_id: this.props.match.params.id,
    };
    let header = this.refs.request_api.header('application/json');
    let self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigtrip') + '/usuario/grupos/permissao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data_groups: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });

    // Salva grupos do sigmec
    let datasave_sigmec = {
      data: this.state.data_groups_sigmec,
      user_id: this.props.match.params.id,
    };

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/usuario/grupos/permissao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave_sigmec) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data_groups_sigmec: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });

    // Salva grupos do sigtrein
    let datasave_sigtrein = {
      data: this.state.data_groups_sigtrein,
      user_id: this.props.match.params.id,
    };

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigtrein') + '/usuario/grupos/permissao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave_sigtrein) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data_groups_sigtrein: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });

    // salva infos do usuario
    let datasave_info = {
      sigtrip: this.state.sigtrip,
      sigrfms: 1,
      sigmec: this.state.sigmec,
      sigtrein: this.state.sigtrein,
      exam: 1,
      exam_instructor: this.state.exam_instructor,
      real_time_labor: this.state.real_time_labor,
      dashboard: this.state.dashboard,
      sigs_ai: this.state.sigs_ai,
      instruction_sheets: this.state.instruction_sheets,
      reports_hub: this.state.reports_hub,
      planejamento: this.state.planejamento,
      segvoos: this.state.segvoos,
      escalas: this.state.escalas,
      portal: this.state.portal,
      email: this.state.email,
      sigtrip_id: this.state.sigtrip_id,
      sigmec_id: this.state.sigmec_id,
      sigtrein_id: this.state.sigtrein_id,
      name: this.state.name,
      id: this.state.id,
    };

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigtrip') + '/usuario/completo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave_info) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            name: responseJson.data.name,
            sigtrip_id: responseJson.data.sigtrip_id,
            sigmec_id: responseJson.data.sigmec_id,
            sigtrein_id: responseJson.data.sigtrein_id,
            email: responseJson.data.email,
            sigrfms: 1,
            sigtrein: responseJson.data.sigtrein,
            exam_instructor: responseJson.data.exam_instructor,
            sigmec: responseJson.data.sigmec,
            real_time_labor: responseJson.data.real_time_labor,
            dashboard: responseJson.data.dashboard,
            sigs_ai: responseJson.data.sigs_ai,
            instruction_sheets: responseJson.data.instruction_sheets,
            reports_hub: responseJson.data.reports_hub,
            planejamento: responseJson.data.planejamento,
            segvoos: responseJson.data.segvoos,
            escalas: responseJson.data.escalas,
            portal: responseJson.data.portal,
          });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Sincronizar informações de usuários
  syncInfo(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigtrip') + '/usuario/sincronizar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            name: responseJson.data.name,
            sigtrip_id: responseJson.data.sigtrip_id,
            sigmec_id: responseJson.data.sigmec_id,
            sigtrein_id: responseJson.data.sigtrein_id,
            email: responseJson.data.email,
            sigtrip: responseJson.data.sigtrip,
            sigrfms: 1,
            sigtrein: responseJson.data.sigtrein,
            exam_instructor: responseJson.data.exam_instructor,
            sigmec: responseJson.data.sigmec,
            real_time_labor: responseJson.data.real_time_labor,
            dashboard: responseJson.data.dashboard,
            sigs_ai: responseJson.data.sigs_ai,
            instruction_sheets: responseJson.data.instruction_sheets,
            reports_hub: responseJson.data.reports_hub,
            planejamento: responseJson.data.planejamento,
            segvoos: responseJson.data.segvoos,
            escalas: responseJson.data.escalas,
            portal: responseJson.data.portal,
          });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  addCompany(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      user_id: this.state.id,
      company_id: this.state.company_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigtrip') + '/usuario/empresa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({ loaded: 1 });
        self.setState({user_companies: responseJson.data});
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  deleteCompany(id) {
    if (window.confirm('Tem certeza que deseja excluir?')) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api_sigtrip') + '/usuario/empresa/' + id, { method: 'DELETE', mode: 'cors', headers: value, }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ loaded: 1 });
          self.setState({user_companies: responseJson.data});
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Editar usuário</h3>
      <Link to="/usuarios" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <button className="btn btn-success button-inline pull-right" title="Sincronizar informações de usuário entre sistemas" alt="Sincronizar informações de usuário entre sistemas" onClick={this.syncInfo}><i className="fa fa-refresh"></i> Sincronizar</button>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Nome:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>E-mail:</label>
            <input type="text" className="form-control" name="email" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>Funcionário SIGTRIP:</label>
            <Select
              className=""
              name="sigtrip_id"
              value={this.state.sigtrip_id}
              searchable={true}
              placeholder={'Selecionar funcionário'}
              onChange={this.handleSelectChange.bind(this, 'sigtrip_id')}
              options={this.state.staff_list_sigtrip}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>Funcionário SIGMEC:</label>
            <Select
              className=""
              name="sigmec_id"
              value={this.state.sigmec_id}
              searchable={true}
              placeholder={'Selecionar funcionário'}
              onChange={this.handleSelectChange.bind(this, 'sigmec_id')}
              options={this.state.staff_list_sigmec}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>Funcionário SIGTREIN:</label>
            <Select
              className=""
              name="sigtrein_id"
              value={this.state.sigtrein_id}
              searchable={true}
              placeholder={'Selecionar funcionário'}
              onChange={this.handleSelectChange.bind(this, 'sigtrein_id')}
              options={this.state.staff_list_sigtrein}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Usado em SIGTRIP?</label>
            <br/>
            <Toggle
              checked={this.state.sigtrip}
              aria-label='No label tag'
              name="sigtrip"
              onChange={this.handleToggleChange.bind(this, 'sigtrip')} />
          </div>
          <div className="col-md-6 form-group">
              <label>Usado em SIGMEC?</label>
              <br/>
              <Toggle
                checked={this.state.sigmec}
                aria-label='No label tag'
                name="sigmec"
                onChange={this.handleToggleChange.bind(this, 'sigmec')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Usado em SIGTREIN?</label>
            <br/>
            <Toggle
              checked={this.state.sigtrein}
              aria-label='No label tag'
              name="sigtrein"
              onChange={this.handleToggleChange.bind(this, 'sigtrein')} />
          </div>
          <div className="col-md-6 form-group">
              <label>Usado em Portal do Usuário?</label>
              <br/>
              <Toggle
                checked={true}
                aria-label='No label tag'
                name="sigrfms"
                disabled />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
              <label>Usado em Controle de Prova?</label>
              <br/>
              <Toggle
                checked={true}
                aria-label='No label tag'
                name="exam"
                disabled />
          </div>
          <div className="col-md-6 form-group">
              <label>Usado em Controle de Prova (Instrutor)?</label>
              <br/>
              <Toggle
                checked={this.state.exam_instructor}
                aria-label='No label tag'
                name="exam_instructor"
                onChange={this.handleToggleChange.bind(this, 'exam_instructor')} />
          </div>
        </div>
        <div className="row">
          {clientAccessFields.map(function(field) {
            return (
              <div className="col-md-6 form-group" key={field.key}>
                <label>{field.label}</label>
                <br/>
                <Toggle
                  checked={self.state[field.key]}
                  aria-label='No label tag'
                  name={field.key}
                  onChange={self.handleToggleChange.bind(self, field.key)} />
              </div>
            );
          })}
        </div>
      </form>
      <hr/>
      <h3 className="page-title">Grupos de permissões - SIGTRIP</h3>
      <hr/>
      <form onSubmit={this.editGroups}>
        <div className="row">
          {Object.keys(self.state.data_groups).map(function(k) {
            return (
              <div className="col-md-3 col-md-offset-1">
                <div className="form-group">
                  <label>
                    <input
                      name="checkbox"
                      label={self.state.data_groups[k].group}
                      type="checkbox"
                      checked={self.state.data_groups[k].checked}
                      onChange={self.handleCheckboxChangeGroups.bind(self, self.state.data_groups[k].id)} />
                    {self.state.data_groups[k].group}
                  </label>
                </div>
              </div>
            );
          })}
        </div>
      </form>
      <hr/>
      <h3 className="page-title">Grupos de permissões - SIGMEC</h3>
      <hr/>
      <form onSubmit={this.editGroupsSigmec}>
        <div className="row">
          {Object.keys(self.state.data_groups_sigmec).map(function(k) {
            return (
              <div className="col-md-3 col-md-offset-1">
                <div className="form-group">
                  <label>
                    <input
                      name="checkbox"
                      label={self.state.data_groups_sigmec[k].group}
                      type="checkbox"
                      checked={self.state.data_groups_sigmec[k].checked}
                      onChange={self.handleCheckboxChangeGroupsSigmec.bind(self, self.state.data_groups_sigmec[k].id)} />
                    {self.state.data_groups_sigmec[k].group}
                  </label>
                </div>
              </div>
            );
          })}
        </div>
      </form>
      <hr/>
      <h3 className="page-title">Grupos de permissões - SIGTREIN</h3>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          {Object.keys(self.state.data_groups_sigtrein).map(function(k) {
            return (
              <div className="col-md-3 col-md-offset-1">
                <div className="form-group">
                  <label>
                    <input
                      name="checkbox"
                      label={self.state.data_groups_sigtrein[k].group}
                      type="checkbox"
                      checked={self.state.data_groups_sigtrein[k].checked}
                      onChange={self.handleCheckboxChangeGroupsSigtrein.bind(self, self.state.data_groups_sigtrein[k].id)} />
                    {self.state.data_groups_sigtrein[k].group}
                  </label>
                </div>
              </div>
            );
          })}
        </div>
        <div className="row">
          <div className="col-md-4">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar</button>
          </div>
          <div className="col-md-4">
            <button type="button" className="btn btn-info btn-lg btn-block" onClick={() => {self.loadData()}}><i className="fa fa-fw fa-trash"></i> Limpar</button>
          </div>
          <div className="col-md-4">
            <button className="btn btn-success btn-lg btn-block" title="Sincronizar informações de usuário entre sistemas" alt="Sincronizar informações de usuário entre sistemas" onClick={this.syncInfo}><i className="fa fa-refresh"></i> Sincronizar</button>
          </div>
        </div>
      </form>
      <hr />
      <h3>Empresas</h3>
      <hr />
      <h4>Adicionar empresa</h4>
      <hr />
      <form onSubmit={this.addCompany}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Empresa:</label>
              <Select
                className="form-field-name"
                name="company_id"
                value={this.state.company_id}
                searchable={true}
                placeholder="Selecione"
                onChange={this.handleSelectChange.bind(this, 'company_id')}
                options={this.state.companies_select}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar</button>
            </div>
          </div>
        </div>
      </form>
      <hr />
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th>Empresa</th>
              <th></th>
            </tr>
          </thead>
          <tbody id="dates">
          {Object.keys(self.state.user_companies).map(function(k) {
            var user_company = self.state.user_companies[k];
            return (
              <tr>
                <td>{user_company.company}</td>
                <td className="text-center">
                  <button onClick={() => self.deleteCompany(user_company.id)} className="btn btn-danger btn-sm"><i className="fa fa-trash"></i></button>
                </td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default SigtripUsersEdit;



// WEBPACK FOOTER //
// ./src/Components/Users/UsersEdit.js